export const getVoteStats = (data: any) => {
    const total = data?.total_voters || 0;

    const partyData: Record<string, number> = data?.gotv_party || {};

    const voted = Object.values(partyData).reduce((a, b) => a + (b as number), 0);

    const notVoted = total - voted;

    const percent = total ? (voted / total) * 100 : 0;

    return { total, voted, notVoted, percent };
};
